import { mediaBreakpointUp, paddingY } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled, { css } from 'styled-components';

export const Footer = styled.footer<{ $background?: string }>`
  ${(props) =>
    props.$background &&
    css`
      background: ${props.$background};
      background-position: center top;
      background-size: cover;
      background-repeat: no-repeat;

      ${paddingY(50)}

      ${mediaBreakpointUp('tablet')} {
        ${paddingY(56)}
      }

      ${mediaBreakpointUp('desktop')} {
        ${paddingY(108)}
      }

      ${mediaBreakpointUp('desktopWide')} {
        ${paddingY(180)}
      }
    `};
`;

export const Heading = styled.h3`
  ${customTextSize(32, 38)}
  text-align: center;
  letter-spacing: -0.01em;
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  margin-bottom: 30px;

  ${mediaBreakpointUp('tablet')} {
    margin-bottom: 20px;
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(49, 58)}
    margin-bottom: 30px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;


  ${mediaBreakpointUp('tablet')} {
    flex-direction: row;
    align-items: center;
  }
`;
